import { render } from "./AccordionItem.vue?vue&type=template&id=7237e857"
import script from "./AccordionItem.vue?vue&type=script&lang=js"
export * from "./AccordionItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/System/Compenents/Accordion/AccordionItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7237e857"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7237e857', __exports__)) {
    api.reload('7237e857', __exports__)
  }
  
  module.hot.accept("./AccordionItem.vue?vue&type=template&id=7237e857", () => {
    api.rerender('7237e857', render)
  })

}


export default __exports__